import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { BaseModalComponent } from '../../base-modal/base-modal.component';
import { UsbBaseModalComponent } from '../../usb-base-modal/usb-base-modal.component';

export type DeleteTransferModalAction = 'delete' | 'deleteRoundTrip' | 'cancel';

@Component({
  selector: 'usb-delete-transfer-modal',
  templateUrl: './delete-transfer-modal.component.html',
  styleUrls: ['./delete-transfer-modal.component.scss']
})
export class DeleteTransferModalComponent extends BaseModalComponent implements AfterViewInit {
  public icon: string = '';
  public titleReverse: boolean = false;
  public confirmText: string = 'Eliminar traslado';
  public extraText: string = 'Eliminar ida y vuelta';
  public cancelText: string = 'Cancelar';

  public actionResult: Subject<DeleteTransferModalAction> = new Subject<DeleteTransferModalAction>();

  @ViewChild(UsbBaseModalComponent) usbBaseModal!: UsbBaseModalComponent;

  constructor(public bsModalRef: BsModalRef) {
    super();
  }

  ngAfterViewInit(): void {
    // Forward events from UsbBaseModalComponent to this component's actionResult
    if (this.usbBaseModal) {
      this.usbBaseModal.confirmResult.subscribe((result: boolean) => {
        this.confirmResult.next(result);
        this.actionResult.next(result ? 'delete' : 'cancel');
      });
      this.usbBaseModal.extra.subscribe(() => {
        this.actionResult.next('deleteRoundTrip');
      });
    }
  }

  protected onInit(): void {
    // Delete-transfer-specific initialization if needed
  }
}
